'use strict';

var MarketAnalysisModeDirective = function MarketAnalysisModeDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/market-product-group-mode.html'),
    controller: 'MarketProductGroupModeController',
    scope: {
      changeFilter: '&',
      filterData: '=',
      serviceFilterData: '=',
      scenarioName: '=?',
      screenState: '=',
      reoptPreviewData: '='
    },
    link: function link(scope) {
      scope.$on('market-analysis-toggle:toggleMode', function (event, mode) {
        scope.setMarketProductViewReady(mode === 'market-product-group');
      });
      scope.$on('brush-filter:defaultBrush', scope.onBrushFilter);
      scope.$on('grid:rowSelectionChanged', scope.onRowSelection);
      scope.setSearchRule();
    }
  };
};
MarketAnalysisModeDirective.$inject = [];
module.exports = MarketAnalysisModeDirective;